module.exports = __webpack_public_path__ + "static/media/location.51492c3e.svg";